module.exports = __webpack_public_path__ + "img/ic_32_workout_high.127ade72.svg";